'use client'

import { motion } from 'framer-motion'
import { useState, useEffect } from 'react'
import {
	Gift,
	ExternalLink
} from 'lucide-react'

const Cagnotte = () => {
	const youtubeVideoId = "0uZ3f4KYeI8";
	const embedUrl = `https://www.youtube.com/embed/${youtubeVideoId}?autoplay=1&mute=1&loop=1&playlist=${youtubeVideoId}&controls=0&showinfo=0&rel=0&modestbranding=1&iv_load_policy=3&disablekb=1`;

	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkMobile = () => {
			setIsMobile(window.innerWidth < 768);
		};

		checkMobile();
		window.addEventListener('resize', checkMobile);
		return () => window.removeEventListener('resize', checkMobile);
	}, []);

	return (
		<section
			id="cagnotte"
			className={`relative py-10 px-4 sm:px-6 lg:px-8 overflow-hidden min-h-screen ${
				isMobile ? '' : 'overflow-hidden'
			}`}
			style={isMobile ? { backgroundColor: '#ebe6da' } : {}}
		>

			{!isMobile && (
				<>
					<div className="absolute inset-0 w-full h-full z-0"
						 style={{
							 filter: 'brightness(1.2) contrast(1.1) saturate(1.15)',
						 }}

					>
						<iframe
							src={embedUrl}
							title="Vidéo background Afrique du Sud"
							className="absolute top-1/2 left-1/2"
							style={{
								width: 'max(100vw, 177.78vh)',
								height: 'max(100vh, 56.25vw)',
								transform: 'translate(-50%, -50%)',
								pointerEvents: 'none'
							}}
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay 'src'"
							allowFullScreen={false}
						></iframe>
					</div>

					<div className="absolute inset-0 bg-black bg-opacity-40 z-10"></div>
				</>
			)}

			<div className={`${isMobile ? '' : 'relative z-20'} max-w-7xl mx-auto`}>
				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8 }}
					viewport={{ once: true }}
					className="text-center mb-12"
				>
					<div className="border-4 border-white p-2 rounded-3xl shadow-xl">
						<div className={`rounded-2xl shadow-lg p-6 md:p-8 border-2 border-bordeaux-400 ${
							isMobile
								? 'bg-white'
								: 'bg-white backdrop-blur-sm'
						}`}>
							<p className={`text-lg md:text-xl leading-relaxed ${
								isMobile ? 'text-gray-800' : 'text-gray-800'
							}`}>
								Hello à toutes et à tous !
								Comme vous le savez déjà, nous vous attendons avec impatience le 5 décembre prochain au Manoir de Corny pour célébrer notre mariage ! 🎄🍾🥳🤵👰
								<br/>
								<br/>
								Jadis, les us et coutumes voulaient qu'une liste de mariage soit dressée pour permettre aux époux d'aménager et agrémenter le nouveau logis familial.
								Néanmoins, vous n'êtes pas sans savoir que vos doudous préférés vont bientôt entamer leur 9ème année de colocation.
								C'est pourquoi, plutôt que de vous dresser une liste de passoires, casseroles, service couverts Degrenne ou autres accessoires thermomix que nous possédons déjà (en partie), nous vous proposons, si vous le souhaitez, de participer à notre cagnotte pour notre voyage de noces.
								<br/>
								<br/>
								Nous partirons 🥁🥁🥁🥁🥁🥁... En Afrique du Sud 🇿🇦, pour un voyage unique, mêlant safaris, dégustations de vins locaux, randonnées sur les sommets de Captown et bien d'autres activités tout aussi exaltantes, durant 3 semaines, et un départ prévu quelques jours seulement après notre union.
								Nous avons hâte de partager avec vous ce road trip version 2025.
								Soyez-en sûrs, vous aurez le droit à un reportage photos et vidéos au jour le jour comme celui de 2024 🇺🇲🇨🇦, mais en version nettement améliorée !
							</p>
						</div>
					</div>
				</motion.div>

				<motion.div
					initial={{ opacity: 0, y: 30 }}
					whileInView={{ opacity: 1, y: 0 }}
					transition={{ duration: 0.8, delay: 0.2 }}
					viewport={{ once: true }}
					className="max-w-4xl mx-auto"
				>
					{/* Container */}
					<div className={`rounded-2xl shadow-lg p-6 md:p-8 ${
						isMobile
							? 'bg-white border border-gray-200'
							: 'bg-white bg-opacity-30 backdrop-blur-sm'
					}`}>
						<div className="text-center mb-6">
							<Gift className={`w-10 h-10 md:w-12 md:h-12 mx-auto mb-4 ${
								isMobile
									? 'text-bordeaux-700'
									: 'text-bordeaux-700 drop-shadow-lg'
							}`} />
							<h3 className={`text-2xl md:text-3xl mb-2 font-bold ${
								isMobile
									? 'text-bordeaux-700'
									: 'text-white drop-shadow-lg'
							}`}>
								Comment participer ?
							</h3>
						</div>

						<div className="flex flex-col md:flex-row gap-6 md:gap-8">
							<motion.div
								initial={{ opacity: 0, x: -30 }}
								whileInView={{ opacity: 1, x: 0 }}
								transition={{ duration: 0.6, delay: 0.1 }}
								viewport={{ once: true }}
								className="flex-1 bg-white rounded-2xl shadow-lg p-6 border-2 border-bordeaux-200 hover:border-bordeaux-400 transition-all duration-300"
							>
								<div className="text-center">
									<h4 className="text-bordeaux-700 mb-3 text-xl font-bold">
										Cagnotte en ligne
									</h4>
									<p className="text-gray-700 mb-4 text-sm leading-relaxed">
										Participez facilement et en toute sécurité via notre cagnotte Lydia en ligne.
									</p>
									<a
										href="https://pots.lydia.me/collect/pots?id=7975-mariage-des-doudous"
										target="_blank"
										rel="noopener noreferrer"
										className="btn-secondary w-full inline-flex items-center justify-center gap-2 px-6 py-3"
									>
										<span className="text-lg font-semibold">Je participe</span>
										<ExternalLink className="w-4 h-4" />
									</a>
								</div>
							</motion.div>

							<motion.div
								initial={{ opacity: 0, x: 30 }}
								whileInView={{ opacity: 1, x: 0 }}
								transition={{ duration: 0.6, delay: 0.2 }}
								viewport={{ once: true }}
								className="flex-1 card bg-green-50 border-2 border-green-200 hover:border-green-400 transition-all duration-300"
							>
								<div className="text-center">
									<h4 className="text-green-700 mb-3 text-xl font-bold">
										Don en espèces le jour J
									</h4>
									<p className="text-gray-700 mb-4 text-sm leading-relaxed">
										Une urne sera prévue lors de la réception.
									</p>
									<div className="bg-green-100 text-green-700 px-6 py-3 rounded-lg font-medium">
										Le 5 décembre 2025
									</div>
								</div>
							</motion.div>
						</div>
					</div>
				</motion.div>
			</div>
		</section>
	)
}

export default Cagnotte;
